export const studentGuardiansPath = (studentId) => `/students/${studentId}/guardians`;

export const guardianInvitePath = (studentId) => `/students/${studentId}/guardian-invites`;

export const guardianInviteResendPath = (studentId, inviteId) =>
  `/students/${studentId}/guardian-invites/${inviteId}/resend`;

export const guardianInviteCancelPath = (studentId, inviteId) =>
  `/students/${studentId}/guardian-invites/${inviteId}`;

export const guardianLinkApprovePath = (linkId) => `/students/guardians/${linkId}/approve`;

export const guardianLinkRejectPath = (linkId) => `/students/guardians/${linkId}/reject`;

export const guardianLinkRevokePath = (linkId) => `/students/guardians/${linkId}/revoke`;

export const publicGuardianInvitePath = (token) => `/public/guardian-invites/${token}`;

export const publicGuardianRegisterPath = (token) => `/public/guardian-invites/${token}/register`;

export const publicGuardianConfirmPath = (token) => `/public/guardian-invites/${token}/confirm`;

export const parentChildrenPath = () => '/parent/children';

export const parentApprovedChildrenPath = () => '/parent/children/approved';

export const parentAccessStatusPath = () => '/parent/access-status';
